import React, { useState } from "react";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import skeletonData from "./skeletonData";
import CalculatorInput from "../CalculatorInput/CalculatorInput";
import MaleOrFemale from "../MaleOrFemale/MaleOrFemale";
import CalculatorResult from "../CalculatorResult/CalculatorResult";
import Alert from "../../../Components/Alert/Alert";

export default function Skeleton() {
  const [heightVal, setHeightVal] = useState(0);
  const [WristSizeVal, setWristSizeVal] = useState(0);
  const [showHeightTooltip, setShowHeightTooltip] = useState(false);
  const [showWristTooltip, setShowWristTooltip] = useState(false);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [sex, setSex] = useState("female");
  const [result, setResult] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleInputChange = (val, inputName) => {
    if (inputName === "height") {
      setHeightVal(val);
      setShowHeightTooltip(true);
    } else {
      setWristSizeVal(val);
      setShowWristTooltip(true);
    }
  };

  const handleTouchEnd = (inputName) => {
    if (inputName === "height") {
      setShowHeightTooltip(false);
    } else {
      setShowWristTooltip(false);
    }
  };

  const changeGender = (gender) => {
    setSex(gender);
  };

  const handleComputing = () => {
    if (WristSizeVal !== 0) {
      let skeletonRatio = heightVal / WristSizeVal;
      //Male
      if (skeletonRatio > 10.4 && sex === "male") {
        setResult(`${Math.floor(skeletonRatio)}.0 ریز`);
      } else if (
        skeletonRatio > 9.6 &&
        skeletonRatio < 10.4 &&
        sex === "male"
      ) {
        setResult(`${Math.floor(skeletonRatio)}.0 متوسط`);
      } else if (skeletonRatio < 9.6 && sex === "male") {
        setResult(`${Math.floor(skeletonRatio)}.0 درشت`);
        //Female
      } else if (skeletonRatio > 11 && sex === "female") {
        setResult(`${Math.floor(skeletonRatio)}.0 ریز`);
      } else if (
        skeletonRatio > 10.1 &&
        skeletonRatio < 11 &&
        sex === "female"
      ) {
        setResult(`${Math.floor(skeletonRatio)}.0 متوسط`);
      } else if (skeletonRatio < 10.1 && sex === "female") {
        setResult(`${Math.floor(skeletonRatio)}.0 درشت`);
      } else {
        setResult("");
      }
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
          <BackBtn path="/calculator" />
          <img
            src="/images/ic_menu.svg"
            alt="menu"
            className="menuIcon"
            onClick={hamburgerMenuHandler}
          />
          </div>
          <div className="pageTitle horizontalBorder">نوع استخوان بندی</div>
          <div className="scroll responsiveWidth calculatorPadding">
            <MaleOrFemale
              sex={sex}
              onTransGender={(gender) => changeGender(gender)}
            />
            {skeletonData.map((data) => (
              <CalculatorInput
                key={data.id}
                {...data}
                value={data.name === "قد" ? heightVal : WristSizeVal}
                showTooltip={
                  data.name === "قد" ? showHeightTooltip : showWristTooltip
                }
                onChangeVal={(val) =>
                  handleInputChange(
                    val,
                    data.name === "قد" ? "height" : "wrist"
                  )
                }
                onHide={() =>
                  handleTouchEnd(data.name === "قد" ? "height" : "wrist")
                }
              />
            ))}
            <CalculatorResult
              title="نوع استخوان بندی"
              onCompute={handleComputing}
              result={result}
            />
          </div>
          <Alert
            showAlert={showAlert}
            alertText="دور مچ نباید صفر باشد"
            bottom="5rem"
          />
        </div>
      </div>
    </div>
  );
}
